<template>
  <v-container
    class="ma-0 pa-0 forecasting-page-container"
    fluid
  >
    <div v-if="showAlert">
      <v-alert
        class="v-alert alert_overlay"
        v-model="showAlert"
        border="left"
        close-text="Close Alert"
        dismissible
        :type="alertType"
      >
        {{ alertMsg }}
      </v-alert>
    </div>
    <v-row v-if="export_overlay">
      <v-col cols="12">
        <v-overlay :absolute="true" :value="export_overlay" :z-index="999">
          <v-card class="pa-3 overlay_card">
            <v-row class="full-height-row" justify="center" align="center">
              <v-col cols="auto">
                <v-progress-circular indeterminate size="300" color="black">
                  <v-row
                    class="full-height-row"
                    align="center"
                    justify="center"
                  >
                    <v-col cols="auto" align="center">
                      <span>Please Allow us a Few Minutes to Generate your Export</span>
                    </v-col>
                  </v-row>
                </v-progress-circular>
              </v-col>
            </v-row>
          </v-card>
        </v-overlay>
      </v-col>
    </v-row>
    <v-row class="full-height-row ma-0 pa-0">
      <v-col cols="12" class="full-height-column ma-0 pa-0">
        <!-- Title And Highlights Row-->
        <v-row class="forecasting-header-row ma-0 px-6 pt-4 pb-2">
          <!-- Title Column-->
          <v-col cols="12" class="ma-0 pa-0">
            <v-row width="100%" class="ma-0 pa-0" align="center">
              <v-col cols="auto" class="ma-0 pa-0">
                <v-img :src="main_logo" max-height="48px" max-width="80px" contain></v-img>
              </v-col>
              <v-col cols="auto" class="ma-0 pa-0">
                <span class="page-title">Forecasting</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="ma-0 pa-0 pr-8" align="center" justify="center">
                <span class="plan-title">{{ plan_name }}</span>
              </v-col>
              <v-col class="ma-0 pa-0 px-1" cols="auto" v-if="goto_prediction">
                <v-select
                  v-model="optimization_model_version"
                  :items="optimization_model_options"
                  item-text="text"
                  item-value="value"
                  label="Model"
                  dense
                  outlined
                  hide-details
                  class="optimization-model-select"
                ></v-select>
              </v-col>
              <v-col class="ma-0 pa-0 px-1" cols="auto" v-if="goto_prediction">
                <v-btn
                  outlined color="black"
                  @click="flip_to_prediction" width="150">
                  <v-icon color="black" class="mr-2">mdi-calculator</v-icon>
                  <span class="planning_section_action_text">Optimize</span>
                </v-btn>
              </v-col>
              <v-col class="ma-0 pa-0 px-1" cols="auto" v-if="performance_tab == 'prediction'">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined color="black" width="150px" @click="export_prediction" :disabled="prediction_loading">
                    <v-icon class="mr-2" color="black" v-on="on" >mdi-download</v-icon>
                    <span class="planning_section_action_text">Export</span>
                  </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
              <v-col class="ma-0 pa-0 px-1" cols="auto" v-if="can_edit">
                <v-tooltip top v-if="views_visible && portfolio_type != 'performance'">
                  <template v-slot:activator="{ on }">
                    <v-btn icon elevation="0" v-on="on" @click="views_visible = false">
                      <v-icon color="black">mdi-bookmark-off</v-icon>
                    </v-btn>
                  </template>
                  <TooltipDescription title="Hide Bookmarks" desc_2=""></TooltipDescription>
                </v-tooltip>
              </v-col>
              <v-col class="ma-0 pa-0 px-1" cols="auto" v-if="can_edit">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined color="black" width="150px" @click="edit_plan" :disabled="prediction_loading">
                    <v-icon class="mr-2" color="black" v-on="on" >mdi-pencil</v-icon>
                    <span class="planning_section_action_text">Edit</span>
                  </v-btn>
                  </template>
                  <TooltipDescription title="Reset" desc_2=""></TooltipDescription>
                </v-tooltip>
              </v-col>
              <v-col class="ma-0 pa-0 px-1" cols="auto" v-if="can_edit">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="300"
                  offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on: ontooltip }">
                        <v-btn icon v-on="on" v-bind="attrs" disabled>
                          <v-icon color="black" v-on="ontooltip">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <TooltipDescription title="Reset" desc_2=""></TooltipDescription>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title>Plan Settings</v-card-title>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
            <v-row width="100%" class="ma-0 pa-0">
              <v-tabs v-model="performance_tab" align-tabs="start" light>
                <v-tab v-if="current_planning_stage != 'my_plans'" class="tool-navigation-bar" href="#saved">My Plans</v-tab>
                <v-tab v-if="current_planning_stage != 'my_plans'" class="tool-navigation-bar" href="#opt_setup_new" :disabled="current_planning_stage != 'optimization_setup' && current_planning_stage != 'prediction_stage'">Optimization Setup</v-tab>
                <v-tab v-if="current_planning_stage != 'my_plans'" class="tool-navigation-bar" href="#prediction" :disabled="current_planning_stage != 'prediction_stage'">Optimization</v-tab>
              </v-tabs>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="full-height-row ma-0 pa-0" v-if="!planning_available" align="center" justify="center">
          <v-col cols="auto">
            <v-progress-circular indeterminate size="100"></v-progress-circular>
          </v-col>
        </v-row>
        <v-tabs-items
          class="ma-0 pa-0 tab-content"
          v-model="performance_tab"
          v-if="planning_available"
        >
          <v-tab-item
            class="ma-0 pa-0 tab-item"
            value="saved"
          >
            <v-row width="100%" class="ma-0 pa-0 tab-panel-content">
              <ForecastingSaved
                ref="forecastingSaved"
                :project_id="current_project_id"
                :data_version="current_project_version"
                :data_levels="current_project_levels"
                :project_date_range="current_project_date_range"
                :project_filters="current_project_filters"
                v-on:update_campaign_plan_id="update_campaign_plan_id"
                v-on:create_campaign_plan_id="create_campaign_plan_id"
                v-on:date_update="update_planning_date_range"
                v-on:triggerAlert="triggerAlert">
              </ForecastingSaved>
            </v-row>
          </v-tab-item>
          <v-tab-item
            class="ma-0 pa-0 tab-item"
            value="opt_setup_new"
          >
            <v-row width="100%" class="ma-0 pa-0 tab-panel-content">
              <ForecastingOptimizationSetup
                :key="'optimization-setup-' + opened_plan_component_key + '-' + campaign_plan_id"
                :project_date_range="current_project_date_range"
                :data_levels="current_plan_levels"
                :data_version="current_project_version"
                :project_plan_id="campaign_plan_id"
                :project_filters="current_plan_filters"
                :model_version="optimization_model_version"
                :optimizing="optimize_and_predict"
                :optimization_data_updated="optimization_data_updated"
                :response_curves_key="response_curves_key"
                :active_forecasting_tab="performance_tab"
                :current_planning_stage="current_planning_stage"
                :planning_start_date="planning_start_date"
                :planning_end_date="planning_end_date"
                v-on:triggerAlert="triggerAlert"
                v-on:optimizationSetupComplete="confirm_prediction"
                v-on:optimizationModelVersionResolved="set_optimization_model_version_from_setup"
              ></ForecastingOptimizationSetup>
            </v-row>
          </v-tab-item>
          <v-tab-item
            class="ma-0 pa-0 tab-item"
            value="prediction"
          >
            <v-row width="100%" class="ma-0 pa-0 tab-panel-content">
              <ForecastingPrediction
                v-if="current_planning_stage == 'prediction_stage'"
                :key="'prediction-' + opened_plan_component_key + '-' + campaign_plan_id"
                :project_date_range="current_project_date_range"
                :data_levels="current_project_levels"
                :data_version="current_project_version"
                :project_plan_id="campaign_plan_id"
                :saved="pull_from_saved_opt"
                :version_tag="prediction_version_tag"
                :model_version="optimization_model_version"
                v-on:triggerAlert="triggerAlert"
                v-on:optimization_finished="optimization_finished"
                v-on:prediction_loading_update="update_prediction_loading"
                ref ="planning_prediction_comp"
              ></ForecastingPrediction>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import logo from "@/assets/PlanningLogo.svg";

import ForecastingPrediction from "./ForecastingSetup/ForecastingPrediction.vue";
import ForecastingSaved from "./ForecastingSetup/ForecastingSaved.vue"
import ForecastingOptimizationSetup from "./ForecastingSetup/ForecastingOptimizationSetup.vue";

import TooltipDescription from "@/components/Utility/TooltipDescription.vue";

import api_caller from "@/javascript/data_info.js";
import forecasting_api_caller from "@/javascript/forecasting.js";
import { ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE } from "@/constants/constants";

export default {
  name: "ForecastingBasePage",
  components: {
    ForecastingPrediction,
    ForecastingSaved,
    ForecastingOptimizationSetup,
    TooltipDescription
  },
  mounted() {
    this.reset_project_data();
  },
  beforeDestroy() {
    clearTimeout(this.alertTimeout);
  },
  watch: {
    performance_tab: {
      immediate: true,
      handler: function (newTab, oldTab) {
        if (newTab == "opt_setup_new") {
          this.response_curves_key++;
        } else if (newTab == "saved") {
          this.current_planning_stage = "my_plans";
          if (oldTab) {
            this.refresh_forecasting_reports();
          }
        }
      },
      deep: true,
    },
  },
  data: () => ({
    alertMsg: null,
    alertType: null,
    showAlert: false,
    alertTimeout: null,
    main_logo: logo,
    performance_tab: "saved",

    current_planning_stage: "my_plans",
    planning_date_set: false,

    // Current Project Variables
    current_project_id: null,
    current_project_version: "V3",
    current_project_date_range: { start_date: "2023-01-01", end_date: "2024-02-29" },
    current_project_levels: {
      data_levels: ["channel", "format"],
      selected_levels: ["channel", "format"],
      level_values: [],
    },
    current_project_filters: {},
    current_plan_levels: {
      data_levels: ["channel", "format"],
      selected_levels: ["channel", "format"],
      level_values: [],
    },
    current_plan_filters: {},

    planning_start_date: null,
    planning_end_date: null,
    campaign_plan_id: 13,
    plan_name: '',
    opened_plan_component_key: 0,

    reset_page: false,
    planning_available: true,

    optimize_and_predict: false,
    optimization_data_updated: 0,
    optimization_model_version: "v1",
    optimization_model_options: [
      { text: "Model 1", value: "v1" },
      { text: "Model 2 (beta)", value: "v2" },
    ],
    response_curves_key: 0,
    prediction_loading: false,
    pull_from_saved_opt: false,
    prediction_version_tag: null,
    export_overlay: false,
  }),
  computed: {
    goto_prediction() {
      if (this.current_planning_stage == "optimization_setup") {
        return true;
      }
      return false;
    },
    can_edit() {
      if (this.current_planning_stage == "prediction_stage") {
        return true;
      }
      return false;
    },
  },
  methods: {
    flip_to_prediction: function () {
      this.pull_from_saved_opt = false;
      this.prediction_version_tag = null;
      this.optimize_and_predict = true;
    },
    confirm_prediction: function (version_tag) {
      this.optimize_and_predict = false;
      this.pull_from_saved_opt = false;
      this.prediction_version_tag = version_tag || null;
      this.current_planning_stage = "prediction_stage";
      this.performance_tab = "prediction";
      this.prediction_loading = true;
    },
    optimization_finished: function () {
      this.optimization_data_updated += 1;
      this.prediction_loading = false;
    },
    update_prediction_loading: function (is_loading) {
      this.prediction_loading = is_loading;
    },
    set_optimization_model_version_from_setup: function (modelVersion) {
      const isValidModelVersion = this.optimization_model_options.some((option) => {
        return option.value === modelVersion;
      });
      if (isValidModelVersion) {
        this.optimization_model_version = modelVersion;
      }
    },
    refresh_forecasting_reports: function () {
      this.$nextTick(() => {
        if (
          this.$refs.forecastingSaved &&
          this.$refs.forecastingSaved.get_forecasting_reports
        ) {
          this.$refs.forecastingSaved.get_forecasting_reports();
        }
      });
    },
    reset_project_data: async function () {
      this.planning_available = false;
      if (this.$project.get_val() == null) {
        return;
      }
      let token = await this.$auth.getTokenSilently();
      let project_info = await api_caller
        .get_project_info(token, this.$project.get_val())
        .then((resp) => {
          return resp["data"];
        })
        .catch(() => {
          return "False";
        });
      this.current_project_id = project_info["project_id"];
      this.current_project_version = project_info["version"];
      this.current_project_date_range = {
        start_date: project_info["start_date"],
        end_date: project_info["end_date"],
        min_start_date: project_info["start_date"],
        max_end_date: project_info["end_date"],
      };
      this.current_project_levels = {
        data_levels: project_info["data_levels"],
        selected_levels: [project_info["data_levels"][0]],
        level_values: [],
      };
      this.current_project_filters = project_info['filter_base_values'];
      this.current_plan_levels = this.build_plan_levels();
      this.current_plan_filters = this.current_project_filters;
      this.planning_available = true;
    },

    build_plan_levels: function (selectedLevels = null) {
      let fallbackLevels = [];
      if (this.current_project_levels && Array.isArray(this.current_project_levels["selected_levels"])) {
        fallbackLevels = this.current_project_levels["selected_levels"];
      } else if (this.current_project_levels && Array.isArray(this.current_project_levels["data_levels"])) {
        fallbackLevels = this.current_project_levels["data_levels"];
      }
      const levels = Array.isArray(selectedLevels) && selectedLevels.length > 0
        ? selectedLevels
        : fallbackLevels;

      return {
        data_levels: levels,
        selected_levels: levels,
        level_values: [],
      };
    },

    get_valid_plan_data_levels: function () {
      return ["channel", "format", "media_type"];
    },

    normalize_plan_level_list: function (levels) {
      if (!Array.isArray(levels)) {
        return [];
      }

      const validLevels = this.get_valid_plan_data_levels();
      return levels
        .flatMap((level) => String(level).split(/\s*(?:,|\||\+| - )\s*/))
        .map((level) => level.trim())
        .map((level) => level.toLowerCase())
        .filter((level) => validLevels.includes(level));
    },

    normalize_plan_metadata: function (metadata) {
      const hasReportFilters = metadata && metadata["data_filters"] && typeof metadata["data_filters"] === "object";
      const dataFilters = hasReportFilters
        ? metadata["data_filters"]
        : this.current_project_filters;
      const filterLevels = dataFilters && typeof dataFilters === "object"
        ? this.normalize_plan_level_list(Object.keys(dataFilters))
        : [];
      let orderedLevels = [];
      let rawLevels = metadata
        ? metadata["data_levels"] || metadata["ad_unit"]
        : null;
      if (!rawLevels && !hasReportFilters) {
        rawLevels = this.current_project_levels;
      }

      if (Array.isArray(rawLevels)) {
        orderedLevels = this.normalize_plan_level_list(rawLevels);
      } else if (rawLevels && Array.isArray(rawLevels["selected_levels"])) {
        orderedLevels = this.normalize_plan_level_list(rawLevels["selected_levels"]);
      } else if (rawLevels && Array.isArray(rawLevels["data_levels"])) {
        orderedLevels = this.normalize_plan_level_list(rawLevels["data_levels"]);
      }

      let selectedLevels = orderedLevels;
      if (filterLevels.length > 0 && orderedLevels.length > 0) {
        selectedLevels = orderedLevels.filter((level) => filterLevels.includes(level));
      } else if (orderedLevels.length === 0) {
        selectedLevels = filterLevels;
      }

      return {
        data_levels: this.build_plan_levels(selectedLevels),
        data_filters: dataFilters,
      };
    },

    set_current_plan_metadata: function (metadata) {
      const normalizedMetadata = this.normalize_plan_metadata(metadata);
      this.current_plan_levels = normalizedMetadata["data_levels"];
      this.current_plan_filters = normalizedMetadata["data_filters"];
    },

    campaign_plan_retrived: function () {
      this.current_planning_stage = "prediction_stage";
    },

    update_planning_date_range: function (date) {
      this.planning_date_set = true;
      this.planning_start_date = date["start_date"];
      this.planning_end_date = date["end_date"];
    },

    update_forecasting_report_stage: async function (stage) {
      if (!this.campaign_plan_id || !this.current_project_id) {
        return false;
      }

      let token = await this.$auth.getTokenSilently();
      return forecasting_api_caller
        .update_campaign_plan(token, {
          project_id: this.current_project_id,
          report_id: this.campaign_plan_id,
          stage,
        })
        .then((resp) => {
          return Boolean(resp && resp["success"]);
        })
        .catch(() => {
          return false;
        });
    },

    edit_plan: async function () {
      if (this.prediction_loading) {
        return;
      }
      const stageUpdated = await this.update_forecasting_report_stage("OPTIMIZATION");
      if (!stageUpdated) {
        this.triggerAlert(ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
        return;
      }
      this.pull_from_saved_opt = false;
      this.prediction_version_tag = null;
      this.current_planning_stage = "optimization_setup";
      this.performance_tab = "opt_setup_new";
    },

    create_campaign_plan_id: function (campaign_plan_id, name, reportMetadata) {
      this.campaign_plan_id = campaign_plan_id;
      this.set_current_plan_metadata(reportMetadata);
      this.planning_date_set = true;
      this.performance_tab = "opt_setup_new";
      this.current_planning_stage = "optimization_setup";
      this.prediction_loading = false;
      this.pull_from_saved_opt = false;
      this.prediction_version_tag = null;
      this.plan_name = name;
    },

    update_campaign_plan_id: function (campaign_plan_id, name, stage, reportMetadata) {
      this.opened_plan_component_key += 1;
      this.campaign_plan_id = campaign_plan_id;
      this.set_current_plan_metadata(reportMetadata);
      this.planning_date_set = true;
      this.set_opened_plan_stage(stage);
      this.plan_name = name;
    },

    set_opened_plan_stage: function (stage) {
      const normalizedStage = stage ? stage.toString().toUpperCase() : null;

      if (normalizedStage === "PREDICTION") {
        this.pull_from_saved_opt = true;
        this.prediction_version_tag = null;
        this.current_planning_stage = "prediction_stage";
        this.performance_tab = "prediction";
        this.prediction_loading = true;
        return;
      }

      this.pull_from_saved_opt = false;
      this.prediction_version_tag = null;
      this.current_planning_stage = "optimization_setup";
      this.performance_tab = "opt_setup_new";
      this.prediction_loading = false;
    },

    triggerAlert: function (type, message) {
      this.alertType = type ? type : "info";
      this.alertMsg = message;
      this.showAlert = true;
      clearTimeout(this.alertTimeout);
      this.alertTimeout = setTimeout(() => {
        this.showAlert = false;
        this.alertTimeout = null;
      }, 5000);
    },
    export_prediction: async function () {
      if (this.prediction_loading) {
        return;
      }
      this.export_overlay = true;
      await this.$refs["planning_prediction_comp"].exportPredictionPages(this.plan_name);
      this.export_overlay = false;
    },
  },
};
</script>

<style scoped>

.forecasting-page-container {
  height: calc(100vh - 96px);
  max-height: calc(100vh - 96px);
  overflow-y: hidden;
  width: 100%;
}

.full-height-row,
.full-height-column,
.tab-panel-content {
  height: 100%;
  width: 100%;
}

.forecasting-header-row {
  max-height: 20%;
  min-height: 10%;
}

.tab-content {
  height: calc(100vh - 230px);
  max-height: calc(100vh - 230px);
  width: 100%;
}

.tab-item {
  height: 100%;
  max-height: 100%;
  width: 100%;
}

.page-title {
  font-family: "Poppins" !important;
  font-weight: 800;
  font-size: 2em;
}
.plan-title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 1.4em;
}
.tool-navigation-bar {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.9em !important;
}

.planning_section_action_text {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.9em !important;
  color: black;
}

.optimization-model-select {
  width: 190px;
}

.optimization-model-select ::v-deep .v-select__selection {
  max-width: none;
}

.optimization-model-select ::v-deep .v-select__selection--comma {
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
}

/deep/.v-window__container {
  height: 100% !important;
}
.optimization_calculator_action {
  font-family: 'Poppins' !important;
  font-weight: 400 ;
}
.v-alert {
  position: fixed;
  left: 50%;
  /* bottom: 50px; */
  width: 100%;
  transform: translate(-50%, 0%);
  z-index: 2;
  /* margin: 0 0; */
}
.alert_overlay {
  position: absolute;
  width: 100%;
  z-index: 99;
}

.overlay_card {
  background: white;
  position: fixed;
  height: 100vh;
  width: 100%;
  left: 0;
  right: 0;
  top: 0px;
}
</style>
